import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  priceEntries: 'PriceEntries',
  commodities: 'Commodities',
  inventoryCommodity: 'InventoryCommodity',
  priceSheets: 'PriceSheets',
  priceEntryHistory: 'PriceEntryHistory',
  materialTypes: 'MaterialTypes',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.priceEntries, TAG_TYPES.priceEntryHistory],
  endpoints: {
    getPriceEntries: {
      providesTags: result =>
        result
          ? // successful query
            [
              ...result.map(priceEntry => ({
                type: TAG_TYPES.priceEntries,
                id: priceEntry.id,
              })),
              { type: TAG_TYPES.priceEntries, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PriceEntries', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.priceEntries, id: 'LIST' }],
    },
    getPriceEntry: {
      providesTags: (result, error, { priceEntryId }) => [{ type: TAG_TYPES.priceEntries, id: priceEntryId }],
    },
    createPriceEntry: {
      invalidatesTags: [
        { type: TAG_TYPES.priceEntries, id: 'LIST' },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.commodities },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.materialTypes, id: 'LIST' },
      ],
    },
    updatePriceEntry: {
      invalidatesTags: (result, error, { priceEntryId, materialTypeId }) => [
        { type: TAG_TYPES.priceEntries, id: 'LIST' },
        { type: TAG_TYPES.priceEntries, id: priceEntryId },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.commodities },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.materialTypes, id: 'LIST' },
        { type: TAG_TYPES.materialTypes, id: materialTypeId },
        { type: TAG_TYPES.priceEntryHistory, id: materialTypeId },
      ],
    },
    getPriceEntryHistoryByMaterialId: {
      providesTags: (result, error, { materialTypeId }) => [{ type: TAG_TYPES.priceEntryHistory, id: materialTypeId }],
    },
    deletePriceEntry: {
      invalidatesTags: (result, error, { priceEntryId, materialTypeId }) => [
        { type: TAG_TYPES.priceEntries, id: 'LIST' },
        { type: TAG_TYPES.priceEntries, id: priceEntryId },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.commodities },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.materialTypes, id: 'LIST' },
        { type: TAG_TYPES.materialTypes, id: materialTypeId },
        { type: TAG_TYPES.priceEntryHistory, id: materialTypeId },
      ],
    },
  },
})

export const useGetPriceEntryLazyQuery = api.endpoints.getPriceEntry.useLazyQuery
export const {
  useGetPriceEntriesQuery,
  useGetPriceEntryQuery,
  useCreatePriceEntryMutation,
  useUpdatePriceEntryMutation,
  useGetPriceEntryHistoryByMaterialIdQuery,
  useDeletePriceEntryMutation,
} = api
